import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }
  ComplianceReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/ComplianceReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  BriefingReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/BriefingReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  BriefingReportYear(TokenKey: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/BriefingReportYear';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  MonthlySummaryofDeliveredBriefingsByCompany(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/MonthlySummaryofDeliveredBriefingsByCompany';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  MonthlyBillingOfRegulatoryMonitoringBulletins(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/MonthlyBillingOfRegulatoryMonitoringBulletins';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  CompanySubscriptionReports(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/CompanySubscriptionReports';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IndividualCompanyBriefingSubscriptionReports(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/IndividualCompanyBriefingSubscriptionReports';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }


  BriefingtitlesByJurisdictionReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/BriefingtitlesByJurisdictionReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  BriefingtitlesByBriefingTypeReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/BriefingtitlesByBriefingTypeReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  BriefingProcessingReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/BriefingProcessingReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  VOIPCompanySubscriptionReports(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/VOIPCompanySubscriptionReports';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  VoipTypeReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/VoipTypeReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetYearFromBriefingMaster(TokenKey: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/BriefingReports/GetYearFromBriefingMaster';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetBriefingsDataByYear(TokenKey: string, year: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/BriefingReports/GetBriefingsDataByYear/' + year;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetBriefingStats(TokenKey: any, FromYear: number, ToYear: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/BriefingReports/GetBriefingStats/' + FromYear + '/' + ToYear;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  AllActiveSubscibersReports(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/AllActiveSubscribersReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  VoIPUpdatesCountsByUpdateCategoryReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/VoIPUpdatesCountsByUpdateCategoryReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  VoIPtitlesByJurisdictionReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/VoIPtitlesByJurisdictionReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }


  AllActiveCompanyReports(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/AllActiveCompanyReports';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  WirelessTypeReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/WirelessTypeReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  WirelessByJurisdictionReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/WirelessByJurisdictionReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  WirelessCountsByUpdateCategoryReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/WirelessCountsByUpdateCategoryReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IPCSCompanySubscriptionReports(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/IPCSCompanySubscriptionReports';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IPCSTypeReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/IPCSTypeReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IPCStitlesByJurisdictionReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/IPCStitlesByJurisdictionReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IPCSUpdatesCountsByUpdateCategoryReport(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/IPCSUpdatesCountsByUpdateCategoryReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  AllActiveBriefingCompanySubscription(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/AllActiveBriefingCompanySubscription';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IndividualCompanyBriefingSubscriptionReportsV2(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/V2/IndividualCompanyBriefingSubscriptionReports';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  BriefingProcessingReportV2(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/V2/BriefingProcessingReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  CompanySummaryDeliveredBriefingsbyCompany(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/CompanySummaryDeliveredBriefingsbyCompany';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  MonthlyBillingOfBriefings(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/MonthlyBillingOfBriefings';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  AllActiveSubscibersReportsV2(TokenKey: any, filterModel): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Report/V2/AllActiveSubscribersReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

}
